<div class="container-fluid">
<ngx-spinner
  bdColor="rgba(0,0,0,.85)"
  [fullScreen]="true"
  type="none">

  <div class="loader-content">

    <div class="loader-icon">🎟️</div>

    <div class="loader-spinner"></div>

    <h2>Your AIEventzo Pass is on its way</h2>

    <p>We're preparing everything for your event experience.</p>

  </div>

</ngx-spinner>

    <!-- if Registration Open -->
    <mat-card class="example-card">
        <mat-card-header class="event-header">
            <mat-card-title class="title">
                <img class="event-logo" mat-card-image
                    src="https://aieventzo.com/upload/event_logo/{{event_logo}}" alt="Photo of a Shiba Inu">
                {{event_name}}</mat-card-title>
        </mat-card-header>
        <img class="event-image" mat-card-image src="https://aieventzo.com/upload/event_image/{{event_image}}"
            alt="Photo of a Shiba Inu">

        <mat-card-content *ngIf="showOtpScreen && otpFieldConfig  && registration == 'on'" class="otp-container">

            <div class="otp-header">
                <mat-icon color="primary">lock</mat-icon>
                <h2>{{ otpSent ? 'Verify OTP' : 'Secure Verification' }}</h2>
                <p *ngIf="!otpSent" class="otp-info">
                    Enter your {{ otpFieldConfig.label }} to receive a One-Time Password on WhatsApp

                    <span class="wa-icon">
                        <svg fill="#25d366" width="22px" height="22px" viewBox="0 0 32 32" version="1.1"
                            xmlns="http://www.w3.org/2000/svg">
                            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                            <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                            <g id="SVGRepo_iconCarrier">
                                <title>whatsapp</title>
                                <path
                                    d="M26.576 5.363c-2.69-2.69-6.406-4.354-10.511-4.354-8.209 0-14.865 6.655-14.865 14.865 0 2.732 0.737 5.291 2.022 7.491l-0.038-0.070-2.109 7.702 7.879-2.067c2.051 1.139 4.498 1.809 7.102 1.809h0.006c8.209-0.003 14.862-6.659 14.862-14.868 0-4.103-1.662-7.817-4.349-10.507l0 0zM16.062 28.228h-0.005c-0 0-0.001 0-0.001 0-2.319 0-4.489-0.64-6.342-1.753l0.056 0.031-0.451-0.267-4.675 1.227 1.247-4.559-0.294-0.467c-1.185-1.862-1.889-4.131-1.889-6.565 0-6.822 5.531-12.353 12.353-12.353s12.353 5.531 12.353 12.353c0 6.822-5.53 12.353-12.353 12.353h-0zM22.838 18.977c-0.371-0.186-2.197-1.083-2.537-1.208-0.341-0.124-0.589-0.185-0.837 0.187-0.246 0.371-0.958 1.207-1.175 1.455-0.216 0.249-0.434 0.279-0.805 0.094-1.15-0.466-2.138-1.087-2.997-1.852l0.010 0.009c-0.799-0.74-1.484-1.587-2.037-2.521l-0.028-0.052c-0.216-0.371-0.023-0.572 0.162-0.757 0.167-0.166 0.372-0.434 0.557-0.65 0.146-0.179 0.271-0.384 0.366-0.604l0.006-0.017c0.043-0.087 0.068-0.188 0.068-0.296 0-0.131-0.037-0.253-0.101-0.357l0.002 0.003c-0.094-0.186-0.836-2.014-1.145-2.758-0.302-0.724-0.609-0.625-0.836-0.637-0.216-0.010-0.464-0.012-0.712-0.012-0.395 0.010-0.746 0.188-0.988 0.463l-0.001 0.002c-0.802 0.761-1.3 1.834-1.3 3.023 0 0.026 0 0.053 0.001 0.079l-0-0.004c0.131 1.467 0.681 2.784 1.527 3.857l-0.012-0.015c1.604 2.379 3.742 4.282 6.251 5.564l0.094 0.043c0.548 0.248 1.25 0.513 1.968 0.74l0.149 0.041c0.442 0.14 0.951 0.221 1.479 0.221 0.303 0 0.601-0.027 0.889-0.078l-0.031 0.004c1.069-0.223 1.956-0.868 2.497-1.749l0.009-0.017c0.165-0.366 0.261-0.793 0.261-1.242 0-0.185-0.016-0.366-0.047-0.542l0.003 0.019c-0.092-0.155-0.34-0.247-0.712-0.434z">
                                </path>
                            </g>
                        </svg>
                    </span>
                </p>

                <p *ngIf="otpSent" class="otp-info">
                    OTP has been sent to WhatsApp <strong>{{ otpContact }}</strong>

                    <span class="wa-icon">
                        <svg fill="#25d366" width="22px" height="22px" viewBox="0 0 32 32" version="1.1"
                            xmlns="http://www.w3.org/2000/svg">
                            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                            <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                            <g id="SVGRepo_iconCarrier">
                                <title>whatsapp</title>
                                <path
                                    d="M26.576 5.363c-2.69-2.69-6.406-4.354-10.511-4.354-8.209 0-14.865 6.655-14.865 14.865 0 2.732 0.737 5.291 2.022 7.491l-0.038-0.070-2.109 7.702 7.879-2.067c2.051 1.139 4.498 1.809 7.102 1.809h0.006c8.209-0.003 14.862-6.659 14.862-14.868 0-4.103-1.662-7.817-4.349-10.507l0 0zM16.062 28.228h-0.005c-0 0-0.001 0-0.001 0-2.319 0-4.489-0.64-6.342-1.753l0.056 0.031-0.451-0.267-4.675 1.227 1.247-4.559-0.294-0.467c-1.185-1.862-1.889-4.131-1.889-6.565 0-6.822 5.531-12.353 12.353-12.353s12.353 5.531 12.353 12.353c0 6.822-5.53 12.353-12.353 12.353h-0zM22.838 18.977c-0.371-0.186-2.197-1.083-2.537-1.208-0.341-0.124-0.589-0.185-0.837 0.187-0.246 0.371-0.958 1.207-1.175 1.455-0.216 0.249-0.434 0.279-0.805 0.094-1.15-0.466-2.138-1.087-2.997-1.852l0.010 0.009c-0.799-0.74-1.484-1.587-2.037-2.521l-0.028-0.052c-0.216-0.371-0.023-0.572 0.162-0.757 0.167-0.166 0.372-0.434 0.557-0.65 0.146-0.179 0.271-0.384 0.366-0.604l0.006-0.017c0.043-0.087 0.068-0.188 0.068-0.296 0-0.131-0.037-0.253-0.101-0.357l0.002 0.003c-0.094-0.186-0.836-2.014-1.145-2.758-0.302-0.724-0.609-0.625-0.836-0.637-0.216-0.010-0.464-0.012-0.712-0.012-0.395 0.010-0.746 0.188-0.988 0.463l-0.001 0.002c-0.802 0.761-1.3 1.834-1.3 3.023 0 0.026 0 0.053 0.001 0.079l-0-0.004c0.131 1.467 0.681 2.784 1.527 3.857l-0.012-0.015c1.604 2.379 3.742 4.282 6.251 5.564l0.094 0.043c0.548 0.248 1.25 0.513 1.968 0.74l0.149 0.041c0.442 0.14 0.951 0.221 1.479 0.221 0.303 0 0.601-0.027 0.889-0.078l-0.031 0.004c1.069-0.223 1.956-0.868 2.497-1.749l0.009-0.017c0.165-0.366 0.261-0.793 0.261-1.242 0-0.185-0.016-0.366-0.047-0.542l0.003 0.019c-0.092-0.155-0.34-0.247-0.712-0.434z">
                                </path>
                            </g>
                        </svg>
                    </span>
                </p>

            </div>

            <mat-form-field appearance="outline" class="w-100" *ngIf="!otpSent">
                <mat-label>Whatsapp {{ otpFieldConfig.label }}</mat-label>
                <input matInput type="tel" [maxlength]="10" [(ngModel)]="otpContact" required autocomplete="off" />
                <mat-icon matSuffix>phone</mat-icon>
            </mat-form-field>

            <button mat-raised-button color="primary" class="w-100 otp-btn" (click)="sendOtp()" *ngIf="!otpSent">
                Send OTP
            </button>

            <mat-form-field appearance="outline" class="w-100 otp-input" *ngIf="otpSent">
                <mat-label>Enter 4-digit OTP</mat-label>
                <input matInput type="text" maxlength="4" inputmode="numeric" [(ngModel)]="otpValue"
                    autocomplete="one-time-code" />
                <mat-icon matSuffix>vpn_key</mat-icon>
            </mat-form-field>

            <button mat-raised-button color="accent" class="w-100 otp-btn" (click)="verifyOtp()"
                [disabled]="otpValue?.length !== 4" *ngIf="otpSent">
                Verify OTP
            </button>

            <div class="otp-actions" *ngIf="otpSent">
                <button mat-button color="primary" (click)="otpSent=false; otpValue=''">
                    Change {{ otpFieldConfig.label }}
                </button>
                <button mat-button color="warn" (click)="sendOtp()">
                    Resend OTP
                </button>
            </div>

        </mat-card-content>


        <mat-card-content *ngIf="!showOtpScreen && isapproved && !isover && !isFull && registration == 'on'">
            <p style="font-size: 15px;" [innerHTML]="description | sanitizeHtml"></p>

            <hr>

            <!-- Image Cropper Section -->
            <div *ngIf="showCropper" class="cropper-container">
                <image-cropper [imageChangedEvent]="imageChangedEvent" [maintainAspectRatio]="true"
                    [aspectRatio]="1 / 1" format="jpeg" [resizeToWidth]="512" [resizeToHeight]="512"
                    [onlyScaleDown]="true" [imageQuality]="100" (imageCropped)="imageCropped($event)"
                    (cropperReady)="cropperReady()" (loadImageFailed)="showCropper = false">
                </image-cropper>

                <div class="mt-2 d-flex justify-content-end">
                    <button class="me-2" mat-raised-button color="warn" (click)="showCropper=false">Cancel</button>
                    <button mat-raised-button color="primary" (click)="uploadCroppedImage()">Crop & Upload</button>
                </div>
            </div>

            <div class="row" *ngFor="let element of ELEMENT_DATA">

                <!-- <div *ngIf="element.fields == 'tic_category' && element.hide_show == 1">
                    <mat-label>{{element.label}}<span *ngIf="element.require === true">*</span> :</mat-label>
                    <mat-radio-group *ngFor="let item of event_tic_category" [(ngModel)]="formData[element.fields]">
                        <mat-radio-button value="{{item.category}}"
                            [disabled]="item.disable_category">{{item.category}}</mat-radio-button>
                    </mat-radio-group>
                </div> -->

                <div *ngIf="element.fields === 'tic_category' && element.hide_show == 1">
                    <mat-label>
                        {{ element.label }} <span *ngIf="element.require === true">*</span> :
                    </mat-label>

                    <div *ngFor="let item of event_tic_category">
                        <div class="ticket-row">
                            <div>
                                <strong>{{ item.category }}</strong><br>
                                <span>&#8377;{{ item.price }}</span>
                            </div>

                            <div class="quantity-selector">
                                <button mat-raised-button color="primary"
                                    (click)="decreaseQuantity(item, element.fields)">−</button>

                                <input class="form-control" min="0" [(ngModel)]="item.quantity"
                                    (ngModelChange)="onQuantityChange(item, element.fields)"
                                    style="width: 60px; text-align: center;" />

                                <button mat-raised-button color="primary"
                                    (click)="increaseQuantity(item, element.fields)"
                                    [disabled]="item.quantity >= item.max_allowed">+</button>
                            </div>
                        </div>
                        <hr />
                    </div>

                    <div class="total-price">
                        Total Price:
                        ₹{{ getTotalPrice(element.fields) }}
                    </div>
                </div>


                <!-- Payment Screenshot Upload -->
                <!-- <div *ngIf="element.fields == 'payment_ss' && element.hide_show == 1" class="upload-field-container">

                    <mat-label class="field-label">
                        {{element.label}} <span *ngIf="element.require === true" class="required-star">*</span>
                    </mat-label>

                    <div class="upload-placeholder" (click)="openImageOptions('payment_ss')"
                        [class.has-image]="paymentPath">

                        <div class="image-preview-wrapper" *ngIf="paymentPath">
                            <img [src]="'https://aieventzo.com/upload/' + event_id + '/payment_ss/' + paymentPath"
                                class="preview-img">
                            <div class="edit-overlay">
                                <mat-icon>photo_camera</mat-icon>
                                <span>Change {{element.label}}</span>
                            </div>
                        </div>

                        <div class="empty-state" *ngIf="!paymentPath">
                            <mat-icon class="upload-icon">payments</mat-icon>
                            <span class="upload-text">Upload {{element.label}}</span>
                            <span class="upload-subtext">Click to capture or select from gallery</span>
                        </div>
                    </div>

                    <input type="file" #cameraInput accept="image/*" capture="environment" style="display: none"
                        (change)="handleFileSelection($event)">
                    <input type="file" #galleryInput accept="image/*" style="display: none"
                        (change)="handleFileSelection($event)">
                </div> -->


                <!-- Profile Image Upload -->
                <div *ngIf="element.fields == 'image' && element.hide_show == 1" class="upload-field-container">

                    <mat-label class="field-label">
                        {{element.label}} <span *ngIf="element.require === true" class="required-star">*</span>
                    </mat-label>

                    <div class="upload-placeholder" (click)="openImageOptions('images')" [class.has-image]="imagePath">

                        <div class="image-preview-wrapper" *ngIf="imagePath">
                            <img [src]="'https://aieventzo.com/upload/' + event_id + '/images/' + imagePath"
                                class="preview-img">
                            <div class="edit-overlay">
                                <mat-icon>photo_camera</mat-icon>
                                <span>Change {{element.label}}</span>
                            </div>
                        </div>

                        <div class="empty-state" *ngIf="!imagePath">
                            <mat-icon class="upload-icon">cloud_upload</mat-icon>
                            <span class="upload-text">Tap to upload or take a photo</span>
                            <span class="upload-subtext">Supports: JPG, PNG</span>
                        </div>
                    </div>

                    <input type="file" #cameraInput accept="image/*" capture="environment" style="display: none"
                        (change)="handleFileSelection($event)">
                    <input type="file" #galleryInput accept="image/*" style="display: none"
                        (change)="handleFileSelection($event)">
                </div>

                <!-- ID Proof Field -->
                <div *ngIf="element.fields == 'id_proof' && element.hide_show == 1" class="upload-field-container">

                    <mat-label class="field-label">
                        {{element.label}} <span *ngIf="element.require === true" class="required-star">*</span>
                    </mat-label>

                    <div class="upload-placeholder" (click)="openImageOptions('id_proof')"
                        [class.has-image]="proofPath">

                        <div class="image-preview-wrapper" *ngIf="proofPath">
                            <img [src]="'https://aieventzo.com/upload/' + event_id + '/id_proof/' + proofPath"
                                class="preview-img">
                            <div class="edit-overlay">
                                <mat-icon>badge</mat-icon>
                                <span>Change{{element.label}}</span>
                            </div>
                        </div>

                        <div class="empty-state" *ngIf="!proofPath">
                            <mat-icon class="upload-icon">contact_page</mat-icon>
                            <span class="upload-text">Upload {{element.label}}</span>
                            <span class="upload-subtext">Aadhar, PAN, or Driving License</span>
                        </div>
                    </div>

                    <input type="file" #cameraInput accept="image/*" capture="environment" style="display: none"
                        (change)="handleFileSelection($event)">
                    <input type="file" #galleryInput accept="image/*" style="display: none"
                        (change)="handleFileSelection($event)">
                </div>


                <label
                    *ngIf="element.fields !== 'image' && element.fields !== 'id_proof' && element.fields !== 'tic_category' && element.fields !== 'payment_ss' && element.fields !== 'date' && element.hide_show == 1  && element.type !=='radio' && element.type !=='select' && element.type !=='checkbox'">{{element.label}}<span
                        *ngIf="element.require === true">*</span></label>
                <mat-form-field appearance="outline"
                    *ngIf="element.fields !== 'image' && element.fields !== 'id_proof' && element.fields !== 'tic_category' && element.fields !== 'payment_ss' && element.fields !== 'date' && element.hide_show == 1  && element.type !=='radio' && element.type !=='select' && element.type !=='checkbox'">
                    <input [type]="element.type" matInput [placeholder]="'Please Enter ' + element.label"
                        [(ngModel)]="formData[element.fields]" [required]="element.require" [readonly]="event_id == 47 
                        && isOtpLocked 
                        && element.fields === otpFieldConfig?.fields">
                </mat-form-field>

                <div *ngIf="element.type === 'radio' && element.hide_show == 1 && element.fields !== 'tic_category'"
                    class="mb-3">
                    <mat-label>{{element.label}}<span *ngIf="element.require === '1'">*</span> :</mat-label>
                    <mat-radio-group [(ngModel)]="formData[element.fields]">
                        <mat-radio-button *ngFor="let option of element.value.split(',')" [value]="option">
                            {{option}}
                        </mat-radio-button>
                    </mat-radio-group>

                </div>

                <div *ngIf="element.type === 'checkbox' && element.hide_show == 1 && element.fields !== 'field23'"
                    class="mb-3">

                    <mat-label>
                        {{element.label}}
                        <span *ngIf="element.require == '1'">*</span> :
                    </mat-label>

                    <div class="checkbox-group">
                        <mat-checkbox *ngFor="let option of element.value.split(',')"
                            [checked]="formData[element.fields]?.split(',').includes(option.trim())"
                            (change)="onCheckboxComma(element.fields, option.trim(), $event.checked)">
                            {{option.trim()}}
                        </mat-checkbox>
                    </div>

                </div>


                <div *ngIf="element.fields == 'date' && element.hide_show == 1" class="mb-3">
                    <mat-form-field appearance="outline">
                        <mat-label>{{element.label}}</mat-label>
                        <input matInput [matDatepicker]="picker" [ngModel]="element.type" [min]="minDate"
                            [max]="maxDate" [(ngModel)]="formData[element.fields]"
                            (ngModelChange)="formatDate($event, element.fields)" [required]="element.require">
                        <mat-hint>DD/MM/YYYY</mat-hint>
                        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>
                </div>

                <mat-form-field *ngIf="element.type === 'select' && element.hide_show == 1" appearance="outline">
                    <mat-label>{{element.label}}<span *ngIf="element.require == '1'">*</span> :</mat-label>
                    <mat-select [(ngModel)]="formData[element.fields]">
                        <mat-option *ngFor="let option of element.value.split(',')" [value]="option">
                            {{option}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div *ngIf="hasPaymentScreenshotField()" class="upload-field-container mt-4">

                <mat-label class="field-label">
                    Payment Screenshot <span class="required-star">*</span>
                </mat-label>

                <div class="upload-placeholder" (click)="openImageOptions('payment_ss')"
                    [class.has-image]="paymentPath">

                    <div class="image-preview-wrapper" *ngIf="paymentPath">
                        <img [src]="'https://aieventzo.com/upload/' + event_id + '/payment_ss/' + paymentPath"
                            class="preview-img">

                        <div class="edit-overlay">
                            <mat-icon>photo_camera</mat-icon>
                            <span>Change Screenshot</span>
                        </div>
                    </div>

                    <div class="empty-state" *ngIf="!paymentPath">
                        <mat-icon class="upload-icon">payments</mat-icon>
                        <span class="upload-text">Upload Payment Screenshot</span>
                        <span class="upload-subtext">After payment upload here</span>
                    </div>

                    <input type="file" #cameraInput accept="image/*" capture="environment" style="display: none"
                        (change)="handleFileSelection($event)">
                    <input type="file" #galleryInput accept="image/*" style="display: none"
                        (change)="handleFileSelection($event)">
                </div>
            </div>


            <mat-card-actions class="d-flex flex-column align-items-center mb-4" style="gap: 16px;">
                <!-- Primary Action Button -->
                <!-- <button mat-raised-button
                    style="background: #ffd740; font-size: 18px; font-weight: 600; width: 250px; height: 50px;"
                    (click)="logFormData('checkin')">
                    Register & Check-In
                </button>

                <span style="font-weight: 500; font-size: 16px; color: #555;">OR</span> -->

                <!-- Secondary Action Button -->
                <button mat-raised-button class="register-btn" (click)="logFormData('register')">
                    Confirm Registration
                </button>
            </mat-card-actions>

        </mat-card-content>

        <!-- if Registration Closed -->
        <mat-card-content *ngIf="!isapproved">
            <div style="font-size: larger;font-weight: bold;">
                <p>THIS EVENT IS NOT APPROVED YET. PLEASE CONTACT ADMINISTRATOR FOR MORE INFORMATION.</p>
            </div>
        </mat-card-content>
        <mat-card-content *ngIf="isFull">
            <div style="font-size: larger;font-weight: bold;">
                <p>WE ARE NO LONGER ACCEPTING REGISTRATIONS AS THE EVENT IS FULL.</p>
            </div>
        </mat-card-content>

        <mat-card-content *ngIf="isover || registration == 'off'">
            <div style="font-size: larger;font-weight: bold;">
                <p>EVENT REGISTRATION IS CLOSED. PLEASE CONTACT ADMINISTRATOR FOR MORE INFORMATION.</p>
            </div>
        </mat-card-content>
        <div style="display: flex;align-items: center;margin: 20px;">
            <div class="row">
                <div style="font-weight: 700;margin-right: 20px;">Download
                    Scan Me App :&nbsp;
                    <a href="https://play.google.com/store/apps/details?id=com.vthink.scanme">
                        <img width="25px" height="auto" src="./assets/playstore.png">
                    </a>
                    &nbsp;&nbsp;
                    <a href="https://apps.apple.com/in/app/aieventzo-event-tools/id6448720642">
                        <img width="25px" height="auto" src="./assets/apple.png">
                    </a>
                </div>
            </div>
        </div>

    </mat-card>
</div>
<footer *ngIf="company_ad == 'on'" class="bg-black text-white fixed-bottom">
    <div class="text-center">
        {{company_ad_text}}
    </div>
</footer>